module.exports = __webpack_public_path__ + "media/images/thumbnails/thumb4-10275721d7f31054a35821c7fcc8edd8.jpg";